import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";import { MdEmail } from "react-icons/md";

const DetailsDashboard = ({ org, closePanel, isStarred, onStarToggle }) => {

  
  // ✅ Function to handle email icon click
  const handleEmailClick = () => {
    const userConfirmed = window.confirm("Do you want to open the email compose page?");
    
    if (userConfirmed) {
      window.open("https://mail.google.com/mail/?view=cm&fs=1", "_blank");
    }
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <h2 style={styles.companyName}>{org.orgName}</h2> {/* Use dynamic org name */}
        <div style={styles.iconContainer}>
        <FontAwesomeIcon
  icon={faStar}
  style={{
    fontSize: "16px",
    cursor: "pointer",
    color: isStarred ? "#FF0080" : "#D3D3D3",
    transition: "color 0.2s ease-in-out",
  }}
  onClick={onStarToggle}
/>


          {/* ✅ Updated Email Icon with Click Event */}
          <MdEmail style={styles.icon} onClick={handleEmailClick} />
        </div>
      </div>

      {/* Summary Box */}
      <div style={styles.summaryBox}>
        <span style={styles.summaryNumber}>{org.data.reduce((acc, entry) => acc + entry.value, 0)}</span>
        <span style={styles.summaryText}> total number of audits</span>
      </div>

      {/* Donut Chart */}
      <PieChart width={250} height={200}>
        <Pie
          data={org.data}
          cx="50%"
          cy="50%"
          innerRadius={50}
          outerRadius={100}
          dataKey="value"
          labelLine={false}
          label={({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
            const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
            const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
            const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));
            return (
              <text
                x={x}
                y={y}
                fill="white"
                fontWeight="bold"
                textAnchor="middle"
                dominantBaseline="central"
              >
                {`${(percent * 100).toFixed(0)}%`}
              </text>
            );
          }}
        >
          {org.data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>

      {/* Legend */}
      <div style={styles.legend}>
        {org.data.map((entry, index) => (
          <div key={index} style={styles.legendItem}>
            <span style={{ ...styles.legendDot, backgroundColor: entry.color }}></span>
            {entry.name}
            <span style={styles.legendValue}>{entry.value}</span>
          </div>
        ))}
      </div>

      {/* Tags */}
      <div style={styles.tags}>
        <span style={styles.tag}>India</span>
      </div>

      {/* Close Button */}
      <button style={styles.closeButton} onClick={closePanel}>
        Close
      </button>
    </div>
  );
};

const styles = {
  container: {
    width: "350px",
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
  },
  companyName: {
    fontSize: "16px",
    fontWeight: "normal",
  },
  iconContainer: {
    display: "flex",
    gap: "10px",
  },
  icon: {
    fontSize: "16px",
    cursor: "pointer",
    color: "#FF0080",
  },
  summaryBox: {
    background: "#F4F4F5",
    padding: "10px",
    borderRadius: "6px",
    marginBottom: "15px",
    textAlign: "left",
  },
  summaryNumber: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#000",
  },
  summaryText: {
    fontSize: "12px",
    color: "#666",
    marginLeft: "5px",
  },
  legend: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    margin: "15px 0",
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    fontSize: "12px",
    margin: "5px 0",
  },
  legendDot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    display: "inline-block",
    marginRight: "8px",
  },
  legendValue: {
    marginLeft: "auto",
  },
  tags: {
    display: "flex",
    gap: "5px",
    marginBottom: "15px",
  },
  tag: {
    padding: "5px 10px",
    borderRadius: "10px",
    fontSize: "10px",
    border: "1px solid #E0E0E0",
  },
  closeButton: {
    background: "#FF0080",
    color: "#fff",
    border: "none",
    padding: "8px 15px",
    borderRadius: "5px",
    fontSize: "12px",
    cursor: "pointer",
  },
};

export default DetailsDashboard;
